import Link from "next/link";

import { internalHref } from "../../shared/canonical-url";

export interface BreadcrumbItem {
  name: string;
  href?: string;
}

export default function Breadcrumbs({ trail }: { trail: BreadcrumbItem[] }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="flex flex-wrap items-center gap-1 text-caption text-text-muted"
    >
      {trail.map((item, i) => (
        <span key={i} className="flex items-center gap-1">
          {i > 0 && (
            <span aria-hidden="true" className="select-none">
              ›
            </span>
          )}
          {item.href ? (
            // min-h-6/min-w-6: at least the WCAG 2.2 24px target for an inline
            // crumb; the Hindi "होम" was 16x16 (c-a11y-12).
            <Link
              href={internalHref(item.href)}
              prefetch={false}
              className="inline-flex min-h-6 min-w-6 items-center justify-center transition hover:text-text-primary hover:underline"
            >
              {item.name}
            </Link>
          ) : (
            <span className="text-text-primary">{item.name}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
